import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { UsersTab } from '@/app/(client)/network/-components/companyProfileTabs/users/UsersTab';
import { useCompanyDetail } from '@/app/(client)/network/-hooks/useCompanyDetail';
import { useSessionStore } from '@/store/sessionStore';

const searchSchema = z.object({
  page: z.number().int().min(1).optional(),
  limit: z.number().int().min(10).max(500).optional(),
  sort: z.string().optional(),
  filters: z.record(z.string(), z.array(z.string())).optional(),
});

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/users',
)({
  validateSearch: searchSchema,
  component: UsersRoute,
});

function UsersRoute() {
  const { companyId } = Route.useParams();
  const { data: company } = useCompanyDetail(companyId);
  const user = useSessionStore(s => s.user);
  const isOwnCompany = user?.companyId === (company?.forCompanyId ?? companyId);
  return <UsersTab companyId={companyId} isOwnCompany={isOwnCompany} />;
}
